import { LOAD_DEVICE_STATS_SUCCESS, UNLOAD_DEVICE_STATS } from "./actions";

const initialState = {};

function deviceStatsReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case LOAD_DEVICE_STATS_SUCCESS: {
      const { serviceArgs } = payload;
      const [deviceId] = serviceArgs;

      return {
        deviceId,
        stats: payload.data,
      };
    }
    case UNLOAD_DEVICE_STATS:
      return initialState;
    default:
      return state;
  }
}

export { deviceStatsReducer };
